import {
    saveSettingsEffect,
    updateNotifications,
    revokeAuthorisedDeviceAccess,
    updateNotificationFrequency,
    updateNotificationTime,
    updateEmbedConsent,
    updateLanguageChoice,
    updatePageSaving
} from "@pjs/user-domain";
import { IAppNotification } from "../notifications/interfaces/IAppNotification";
import { IAppDigestSetting } from "../notifications/interfaces/IAppDigestSetting";
import { IAccountSettingsActions } from "./interfaces/IAccountSettingsActions";

const embedConsentUpdateAction = (embedConsent: boolean): void => {
    updateEmbedConsent(embedConsent);
};

const languageChoiceUpdateAction = (languageChoice: string): void => {
    updateLanguageChoice(languageChoice);
};

const pageSavingUpdateAction = (pageSaving: boolean): void => {
    updatePageSaving(pageSaving);
};

const notificationsUpdateAction = (notificationItem: IAppNotification): void => {
    updateNotifications({
        type: notificationItem.type,
        settings: notificationItem.settings
    });
};

const updateNotificationFrequencyAction = (frequency: IAppDigestSetting): void => {
    updateNotificationFrequency(frequency.index);
};

const updateNotificationTimeAction = (time: IAppDigestSetting): void => {
    updateNotificationTime(time.index);
};

export const accountSettingsActions: IAccountSettingsActions = {
    language: {
        languageChoice: languageChoiceUpdateAction
    },
    privacy: {
        embedConsent: embedConsentUpdateAction
    },
    assessment: {
        pageSaving: pageSavingUpdateAction
    },
    notifications: {
        updateNotification: notificationsUpdateAction,
        updateNotificationFrequency: updateNotificationFrequencyAction,
        updateNotificationTime: updateNotificationTimeAction
    },
    externalServices: {
        authorisedDevices: {
            revokeDeviceAccess: revokeAuthorisedDeviceAccess
        }
    },
    saveSettings: saveSettingsEffect
};
